import { css, type Styles } from '@flipster/styled-system/css';
import { BigNumber } from '@flipster/utils/num';

interface TradeBonusProgressProps {
  css?: Styles;
  progress: BigNumber | number; // 0 ~ 100
}
export const TradeBonusProgress = ({ css: cssProp, progress }: TradeBonusProgressProps) => {
  return (
    <div className={css({ h: 6, borderRadius: 1000, bg: 'background.default.level-3', overflow: 'hidden' }, cssProp)}>
      <div
        className={css({
          h: '100%',
          bg: 'background.accent.secondary',
        })}
        style={{ width: `${progress.toString()}%` }}
      />
    </div>
  );
};
